import { handleErrorAxios } from "@/common/lib/formatter";
import Http from "@/common/lib/http";

const actions = {
    async listFilesPaginated(
        { commit, dispatch },
        { complete, keyword, page }
    ) {
        try {
            const { data } = await Http.instance.get("/bo/files", {
                params: { page, complete, keyword }
            });
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    },
    async getEndPointUploadFile(
        { commit, dispatch },
        { alt, fileName, fileSize, type }
    ) {
        try {
            const { data } = await Http.instance.post("/bo/files/upload", {
                alt,
                fileName,
                fileSize,
                type
            });
            commit("SET_URL_UPLOAD", data.urlSigned);
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    },
    async getEndPointUploadPrivateFile(
        { commit, dispatch },
        { fileName, fileSize }
    ) {
        try {
            const { data } = await Http.instance.post(
                "/bo/files/private/upload",
                {
                    fileName,
                    fileSize
                }
            );
            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    },
    async uploadFile({ commit, dispatch }, { file, url }) {
        try {
            const res = await fetch(url, {
                method: "PUT",
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Cache-Control": "max-age=31536000"
                },
                body: file
            });
            const status = res.status;
            return { status };
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    },
    async getFileById({ commit, dispatch, state }, { id }) {
        const file = state.files.find((item) => item.id === id);
        if (file) {
            return {
                ...file,
                createdAt: "2021-10-26T00:27:59.146Z",
                updatedAt: "2021-10-26T00:27:59.146Z"
            };
        }

        try {
            const { data } = await Http.instance.get(`/bo/files/${id}`);

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    },
    async createFile({ commit, dispatch }, { alt, id, type, url }) {
        try {
            const { data } = await Http.instance.post("/bo/files", {
                id,
                url,
                type,
                alt
            });

            const file = {
                url,
                alt,
                type,
                ...data
            };
            return file;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    },
    async updateFile({ commit, dispatch }, { alt, id }) {
        try {
            const { data } = await Http.instance.patch(`/bo/files/${id}`, {
                alt
            });

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    },
    async deleteFile({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.delete(`/bo/files/${id}`);

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    },
    async deleteFileDefinitively({ commit, dispatch }, { id }) {
        try {
            const { data } = await Http.instance.delete(
                `/bo/files/${id}/definitive`
            );

            return data;
        } catch (errorAxios) {
            const parseError = handleErrorAxios(errorAxios, dispatch);
            commit("SET_ERROR_FILES", parseError);
            throw parseError;
        }
    }
};

export default actions;
